import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import {
  User,
  Activity,
  Evidence,
  Link,
  File,
  Report
} from "../../../api/classes";
import { Avatar, Typography, Card, Divider } from "@material-ui/core";
import FileIcon from "@material-ui/icons/Attachment";
import PeopleIcon from "@material-ui/icons/People";
import LinkMeta from "./linkMeta";
import * as moment from "moment";
import CaseFile from "./file";
import TwitterTweetEmbed from "src/components/TwitterEmbed";
import { DEFAULT_AVATAR } from "src/auth/auth";

interface Props {
  report: Report;
  style?: React.CSSProperties;
  files: File[];
  links: Link[];
  timeline?: boolean;
}
class CaseReport extends React.Component<Props> {
  render() {
    const { report, style } = this.props;
    return (
      <Card
        style={{
          ...style,
          display: "flex",
          flexDirection: "column",
          marginTop: 16,
          maxWidth: 450,
          padding: 16,
          marginBottom: 16
        }}
      >
        {this.props.timeline && (
          <div style={{ paddingBottom: 4 }}>
            <div
              style={{ display: "flex", alignItems: "center", marginBottom: 4 }}
            >
              <PeopleIcon style={{ width: 24, height: 24 }} />
              <Typography style={{ marginLeft: 12 }}>Report</Typography>
            </div>
            <Divider />
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            marginBottom: 16
          }}
        >
          <Avatar
            style={{ width: 20, height: 20 }}
            src={report.account_picture || DEFAULT_AVATAR}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <Typography style={{ marginLeft: 8 }} variant="body2">
              {report.account_name}
            </Typography>
            <Typography style={{ marginLeft: 8 }} variant="caption">
              {moment(report.created_at).format("LLL")}
            </Typography>
          </div>
        </div>
        {report.source === "twitter:mention" ? (
          <TwitterTweetEmbed
            text={report.text}
            tweetId={report.external_message_id}
          />
        ) : (
          <Typography
            style={{
              marginLeft: 8,
              fontSize: 13,
              overflowWrap: "break-word",
              wordBreak: "break-all"
            }}
            variant="body2"
          >
            {report.text}
          </Typography>
        )}
        {this.renderFiles()}
        {this.renderLinks()}
      </Card>
    );
  }
  renderFiles() {
    if (this.props.files) {
      return this.props.files.map(a => {
        if (a["report_id"] === this.props.report.id) {
          return <CaseFile key={a.id} file={a} />;
        }
      });
    }
  }
  renderLinks() {
    if (this.props.links) {
      return this.props.links.map(a => {
        if (a["report_id"] === this.props.report.id) {
          return (
            <div key={a.id} style={{}}>
              <LinkMeta link={a} />
            </div>
          );
        }
      });
    }
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseReport);



// WEBPACK FOOTER //
// ./src/pages/cases/components/report.tsx